import React from 'react';
import { Container } from './ui/Container';
export function ProductInUseSection() {
  return <section className="py-16 bg-gray-900 text-white relative overflow-hidden" data-id="element-379">
      <div className="absolute inset-0 bg-blue-900/20" data-id="element-380"></div>
      <Container className="relative z-10" data-id="element-381">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-382">
          <div data-id="element-383">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-384">
              Simple to Use, Impossible to Ignore
            </h2>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-385">
              Mold it to your teeth in 60 seconds. Wear it at night. Wake up to
              silence and a grateful partner.
            </p>
            <ul className="space-y-4" data-id="element-386">
              <li className="flex items-center text-gray-200" data-id="element-387">
                <span className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center mr-3 font-bold" data-id="element-388">
                  1
                </span>
                Dip in warm water to soften
              </li>
              <li className="flex items-center text-gray-200" data-id="element-389">
                <span className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center mr-3 font-bold" data-id="element-390">
                  2
                </span>
                Bite down to create custom mold
              </li>
              <li className="flex items-center text-gray-200" data-id="element-391">
                <span className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center mr-3 font-bold" data-id="element-392">
                  3
                </span>
                Sleep peacefully
              </li>
            </ul>
          </div>
          <div className="relative" data-id="element-393">
            <img src="https://cdn.magicpatterns.com/uploads/ckEK2fDVMho2aEzwy1jUxB/imgi_30_1746975295-SnoreStop™_(1).png" alt="Product in use" className="w-full max-w-md mx-auto drop-shadow-[0_0_30px_rgba(59,130,246,0.5)]" data-id="element-394" />
          </div>
        </div>
      </Container>
    </section>;
}